module.exports = __webpack_public_path__ + "static/media/010.b2c88860.jpg";